// i18n area 'system' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.sk-SK.meta.json.
import type { enUS } from './system'

export const skSK: typeof enUS = {
  diagnostics: {
    title: 'Diagnostika',
    subtitle: 'Čo je zle, najhoršie najprv — rovnaká optika ako tvirt diagnose',
    reload: 'Znova načítať',
    loadError: 'Diagnózu sa nepodarilo prečítať',
    exportBundle: 'Exportovať balíček',
    exportError: 'Balíček sa nepodarilo vytvoriť',
    noProblem: 'V kontrolovaných oblastiach žiadny problém',
    nothingInspected: 'NIČ nebolo skontrolované — to nie je potvrdenie o dobrom zdraví',
    inspected: 'Skontrolované',
    notInspected: 'NESKONTROLOVANÉ',
    localHint: 'Lokálne oblasti uzla (jednotky systemd, journal) sa čítajú len z CLI: tvirt diagnose --area local — cesta, keď API neodpovedá.',
    thresholds: 'neúspešné úlohy za {hours} h, heartbeat oneskorený nad {seconds} s',
    severity: {
      critical: 'Kritické',
      warning: 'Varovanie',
      unknown: 'Neznáme'
    }
  },
  explorer: {
    title: 'Prieskumník zdrojov',
    root: 'Koreň',
    empty: 'V tomto scope nie je žiadny zdroj',
    previewHint: 'Vyberte objekt na zobrazenie jeho ukážky',
    open: 'Otvoriť',

    // Il deep-link ?scope= delle liste CRUD (round #109), dall'esplora (#143).
    openScoped: 'Otvoriť zoznam v tomto scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Šablóna VM',
      ct: 'CT',
      ctTemplate: 'Šablóna CT',
      app: 'App',
      overlayNetwork: 'Overlay sieť',
      networkService: 'Sieťová služba',
      fabric: 'Fabric',
      subnet: 'Podsieť',
      storage: 'Pool úložiska',
      disk: 'Disk',
      catalogFile: 'Súbor katalógu',
      ociRegistry: 'Register OCI',
      ociImage: 'Obraz OCI',
      cephCluster: 'Klaster Ceph',
      backupDestination: 'Cieľ záloh',
      user: 'Používateľ',
      group: 'Skupina',
      role: 'Rola',
      credential: 'Poverenia',
      tag: 'Značka',
      proximityRule: 'Pravidlo blízkosti'
    }
  },
  tags: {
    title: 'Značky',
    empty: 'Žiadne značky',
    add: 'Pridať značku',
    remove: 'Odobrať',
    name: 'Značka',
    value: 'Hodnota',
    save: 'Uložiť',
    saveError: 'Značky sa nepodarilo uložiť',
    loadError: 'Nepodarilo sa načítať slovník značiek',
    noVocabulary: 'Pre tento typ zdroja nie je k dispozícii žiadna značka',

    // A single-valued tag already set answers 409: the replacement is always
    // explicit — never an implicit substitution (design, ratified 2026-07-27).
    overwrite: 'Nahradiť aktuálnu hodnotu',

    // Sistema > Tag, the vocabulary surface.
    createTitle: 'Vytvoriť značku',
    editTitle: 'Upraviť značku',
    nameHint: 'Písmená, číslice, bodky, pomlčky a podčiarkovníky — bez „:“ a bez „/“; predpona tvirt- patrí platforme',
    cardinality: 'Kardinalita',
    cardinalitySingle: 'Jedna hodnota',
    cardinalityMultiple: 'Viac hodnôt',
    cardinalityHint: 'Pri jednej hodnote si opätovné priradenie značky vyžiada jej nahradenie',
    autoCreate: 'Automatické vytváranie hodnôt',
    autoCreateOn: 'Pri priradení',
    autoCreateOff: 'Len deklarované',
    autoCreateHint: 'Zapnuté: priradenie novej hodnoty ju vytvorí. Vypnuté: priraďovať možno len deklarované hodnoty',
    values: 'Hodnoty',
    noValues: 'Žiadna deklarovaná hodnota',
    addValue: 'Pridať hodnotu',
    duplicateValue: 'Duplicitná hodnota',
    kinds: 'Typy zdrojov',
    kindsAll: 'Všetky',
    kindsPlaceholder: 'Všetky',
    kindsHint: 'Nechajte prázdne, ak chcete povoliť každý typ zdroja, ktorý môže niesť značky',
    systemChip: 'Systém',
    deleteCascade: 'Odstrániť aj priradenia',
    deleteCascadeHint: 'Tag, ktorý je stále priradený nejakému prostriedku, sa odmietne: s touto voľbou odídu hodnoty a všetky priradenia spolu s tagom.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Vytvoriť scope',
    editTitle: 'Premenovať scope',
    path: 'Cesta',
    segment: 'Segment',
    segmentHint: 'Malé písmená, číslice a pomlčky (DNS-1123)',
    parent: 'Rodič',
    rootChip: 'Koreň',
    preview: 'Nový scope',
    pickLabel: 'Scope',
    pickHint: 'Kde objekt žije v strome klastra — koreň alebo vDC pod ním.',
    ociCache: 'Cache OCI (override)',
    appEphemeral: 'Efemérny pool pre App (override)',
    inherit: 'Zdediť',
    inheritsFrom: 'Dedí od',
    inheritsCluster: 'Dedí predvolené nastavenie klastra',
    inheritsNone: 'Dedí — žiadny efektívny pool',
    failoverProtection: 'Ochrana pri degradácii',
    networkWeight: 'Sieťová váha',
    networkCeil: 'Sieťový strop (Mbps)',
    protectionProtected: 'Chránené',
    protectionExpendable: 'Obetovateľné pri degradácii',
    protectionDefault: 'Predvolené nastavenie klastra'
  },

  // Sistema > Informazioni (round #124, 2026-07-31): versioni piattaforma
  // nella flotta (al massimo due mid-upgrade), componenti per nodo, manuale
  // PDF servito localmente e card licenza inglobata.
  sysinfo: {
    summary: 'Verzie platformy v klastri, komponenty jednotlivých uzlov, administrátorská príručka a licencia.',
    platformTitle: 'Platforma TVirt',
    platformSubtitle: 'Verzie pozorované na uzloch klastra',
    versionOnNodes: '{version} na {n} uzloch',
    versionOnOneNode: '{version} na 1 uzle',
    mixedVersions: 'Viac ako jedna verzia platformy v klastri — očakávané len počas prebiehajúcej aktualizácie (najviac dve).',
    tooManyVersions: 'Viac ako dve verzie platformy v klastri — to sa neočakáva nikdy, ani počas aktualizácie: skontrolujte uzly nižšie.',
    unreportedNodes: 'Zatiaľ žiadne hlásenie verzií od: {nodes}',
    noVersionsYet: 'Žiadny uzol zatiaľ nenahlásil svoje verzie.',
    nodesUnavailable: 'Zoznam uzlov nie je s vašimi oprávneniami viditeľný — verzie platformy nemožno zobraziť.',
    colNode: 'Uzol',
    manualTitle: 'Administrátorská príručka',
    manualSubtitle: 'Lokálna kópia poskytovaná týmto klastrom',
    manualBody: 'Kompletná príručka TVirt v PDF, poskytovaná priamo platformou — dostupná aj v air-gapped prostrediach.',
    manualLink: 'Administrátorská príručka (PDF)',
    apiExplorerTitle: 'Prieskumník API',
    apiExplorerSubtitle: 'Kontrakt OpenAPI, na prehliadanie',
    apiExplorerBody: 'Úplný kontrakt OpenAPI platformy — každá trasa, schéma a kód odpovede — na prehliadanie z prehliadača, servírovaný cez tento uzol.',
    apiExplorerLink: 'Preskúmať API',
    kubeTitle: 'Kompatibilita s Kubernetes',
    kubeSubtitle: 'kubectl a jeho nástroje pred natívnym API',
    kubeBody: 'TVirt KubeCompat premieta Pody, Deploymenty, Service, menné priestory, uzly a udalosti do dialektu Kubernetes — len na čítanie, plus mazanie Deploymentov. Každé volanie prechádza natívnym API s tvojimi oprávneniami: v kubeconfigu použi app token ako bearer.',
    kubeEndpoint: 'Endpoint pre kubectl',
    kubeStatusActive: 'Aktívny — Kubernetes {version}',
    kubeStatusMissing: 'Na tomto uzle nie je nainštalované (balík trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Nainštalované, ale neodpovedá — skontroluj jednotku trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Kontroluje sa…'
  },

  // Licensing (round 2026-07-29): la pagina della licenza a sottoscrizione.
  licensing: {
    title: 'Licencia klastra',
    subtitle: 'Licencia na predplatné — najviac jedna na klaster',
    absentTitle: 'Žiadna zaregistrovaná licencia',
    absentBody:
      'Bez platnej licencie klaster odmieta spúšťať nové virtuálne stroje (zapnuté VM zostávajú zapnuté). Zaregistrujte produktový kľúč, ktorý ste dostali s predplatným.',
    registerButton: 'Zaregistrovať licenciu',
    removeButton: 'Odobrať licenciu',
    state: {
      ok: 'Platná',
      limitExceeded: 'Limit prekročený',
      expired: 'Platnosť vypršala'
    },
    productKeyLabel: 'Produktový kľúč',
    basisLabel: 'Základ limitu',
    basis: {
      concurrentVms: 'Súbežne zapnuté VM',
      physicalCores: 'Fyzické jadrá (spolu za klaster)'
    },
    limitLabel: 'Limit',
    usageLabel: 'Aktuálne využitie',
    usageOf: '{used} z {limit}',
    usagePartial: 'čiastočný súčet — uzly bez pozorovanej topológie CPU: {n}',
    usageUnknown: 'momentálne nepozorovateľné',
    expiresLabel: 'Vyprší',
    neverExpires: 'nikdy',
    registeredLabel: 'Zaregistrovaná',
    gateNote:
      'S chýbajúcou či vypršanou licenciou alebo nad jej limitom klaster odmieta spúšťať NOVÉ virtuálne stroje. Zapnuté VM zostávajú zapnuté a reštarty HA tým nie sú dotknuté.',
    devStage:
      'Vývojová fáza: produktový kľúč sa prijíma tak, ako je, spolu s limitmi deklarovanými tu; validácia podpísaným kľúčom príde v budúcom vydaní.',
    dialogTitle: 'Zaregistrovať licenciu',
    dialogExpiresHelp: 'Prázdne = platnosť licencie nikdy nevyprší',
    dialogSubmit: 'Zaregistrovať',
    dialogError: 'Licenciu sa nepodarilo zaregistrovať.',
    removeTitle: 'Odobrať licenciu',
    removeBody:
      'Klaster zostane BEZ LICENCIE: nové virtuálne stroje sa odmietnu spustiť, kým nejakú nezaregistrujete. Zapnuté VM zostávajú zapnuté.',
    removeConfirm: 'Odobrať',
    removeError: 'Licenciu sa nepodarilo odobrať.'
  },
  rbac: {
    tabRoles: 'Roly',
    tabGrants: 'Delegácie',
    rolesTitle: 'Roly',
    createRoleTitle: 'Vytvoriť rolu',
    editRoleTitle: 'Upraviť rolu',
    nameHint: 'Malé písmená, číslice a pomlčky; predpona tvirt- je vyhradená',
    systemChip: 'Systém',
    permissions: 'Oprávnenia',
    permissionsPlaceholder: 'Pridať oprávnenie…',
    includedRoles: 'Zahrnuté roly',
    includedRolesPlaceholder: 'Pridať rolu…',
    grantsTitle: 'Delegácie',
    createGrantTitle: 'Vytvoriť delegáciu',
    principal: 'Principal',
    principalKind: 'Typ principalu',
    principalUser: 'Používateľ',
    principalGroup: 'Skupina',
    role: 'Rola',
    grantRight: 'Delegovanie',
    grantRightChip: 'Môže delegovať',
    grantRightLabel: 'S právom delegovať (príjemca môže túto rolu delegovať ďalej)',
    effective: 'Účinná',
    notEffective: 'Neúčinná',
    createdAt: 'Vytvorená',
    scopeHint: '/path presne, /path/* rekurzívne — delegácie sa ukotvujú na pripojený koreň (/* delegovať nemožno)'
  },
  groups: {
    title: 'Skupiny',
    createTitle: 'Vytvoriť skupinu',
    nameHint: 'Malé písmená, číslice a pomlčky; jedinečný v rámci scope',
    members: 'Členovia',
    membersTitle: 'Členovia',
    membersPlaceholder: 'Pridať používateľa…',
    noMembers: 'Žiadni členovia',
    realmMappings: 'Mapovania realmov',
    realmMappingsTitle: 'Mapovania realmov',
    realmMappingsHint:
      'Čomu táto skupina zodpovedá v jednotlivých externých realmoch. Členstvo sa číta z adresára pri prihlásení: adresárová skupina, ktorú tu nikto nemapuje, sa ignoruje, a vnorenie sa nerieši — treba ho sploštiť na strane adresára.',
    realm: 'Realm',
    externalGroup: 'Externá skupina',
    addRealmMapping: 'Pridať mapovanie',
    removeRealmMapping: 'Odobrať mapovanie',
    noRealmMappings: 'Žiadne mapovania realmov',

    // Dialog di creazione a sezioni (round realm-wizard, 2026-08-03): Generale
    // più la superficie di mappatura coi realm esterni, con l'empty state
    // parlante.
    sectionGeneral: 'Všeobecné',
    mappingsNoRealms: 'Žiadny nakonfigurovaný externý realm — plocha mapovania sa odomkne, len čo bude nejaký realm existovať.',
    mappingsNoRealmsLink: 'Otvoriť kartu Realmy a SSO',

    // L'obbligo MFA imposto dal gruppo (round #178 metà B): OR puro — un
    // gruppo può solo AGGIUNGERE l'obbligo, mai toglierlo.
    mfaRequired: 'Povinnosť MFA',
    mfaRequiredChip: 'Vynucuje MFA',
    mfaNotRequiredChip: 'Žiadna povinnosť',
    mfaRequiredHint:
      'Čisté OR: skupina môže povinnosť druhého faktora svojim členom PRIDAŤ — aj externým identitám cez mapovania realmov — nikdy ju zrušiť. Platí od nasledujúceho prihlásenia: otvorené relácie sa nezatvárajú.'
  },
  users: {
    title: 'Používatelia',
    createTitle: 'Vytvoriť používateľa',
    editTitle: 'Upraviť používateľa',
    username: 'Používateľské meno',
    usernameHint: 'Malé písmená, číslice, bodky a pomlčky',
    displayName: 'Zobrazované meno',
    enabled: 'Povolený',
    state: 'Stav',
    enabledChip: 'Povolený',
    disabledChip: 'Zakázaný',
    lockedChip: 'Zamknutý',
    password: 'Heslo',
    passwordSetChip: 'Nastavené',
    mustChangeChip: 'Treba zmeniť',
    initialPassword: 'Počiatočné heslo',
    initialPasswordHint: 'Používateľ si ho bude musieť zmeniť pri prvom prihlásení',
    lastLogin: 'Posledné prihlásenie',
    neverLoggedIn: 'Nikdy neprihlásený',
    setPasswordTitle: 'Nastaviť heslo',
    setPasswordHint: 'Administratívne nahradenie — vyžaduje vaše heslo (režim sudo) a prinúti používateľa zmeniť si ho pri najbližšom prihlásení.',
    operatorPassword: 'Vaše heslo',
    unlock: 'Odomknúť účet',
    revokeTitle: 'Odvolať relácie',
    revokeBody: 'Všetky aktívne relácie tohto používateľa sa okamžite ukončia.',
    revokeIncludeTokens: 'Odvolať aj app tokeny',
    revokeConfirm: 'Odvolať',

    // Dialog standard (round #156): dettagli completi, tab account/sicurezza.
    tabAccount: 'Účet',
    tabSecurity: 'Zabezpečenie',
    usernameImmutableHint: 'Používateľské meno je identita účtu — pevne dané pri vytvorení',
    groups: 'Skupiny',
    noGroups: 'Žiadne skupiny',
    mustChangePassword: 'Povinná zmena hesla',
    failedAttempts: 'Neúspešné pokusy o prihlásenie',
    lockedUntil: 'Zamknutý do',

    // Identity tabs (2026-08-03): Sistema > Utenti è diventata una sezione a
    // tab sul modello di /system/rbac — utenti, gruppi, realm esterni.
    tabUsers: 'Používatelia',
    tabGroups: 'Skupiny',
    tabRealms: 'Realmy a SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178): la vista del secondo fattore. Metà A — la tabella
    // per-utente su users.yaml; metà B (round contract, ratifiche 2026-08-04)
    // — il verdetto efficace con la provenienza, gli enrollment esterni con
    // lo stato orfano e i gruppi che impongono l'obbligo.
    mfa: {
      title: 'Druhý faktor (MFA)',
      methodsTitle: 'Dostupné metódy',
      methodsSubtitle: 'Čo táto inštalácia dokáže overiť ako druhý faktor',
      methodsError: 'Nepodarilo sa načítať register metód',
      builtinChip: 'Vstavaný',
      enrollableChip: 'Enrollment v TVirt',
      delegatedChip: 'Spravované externe',
      state: 'Stav',
      stateActive: 'Aktívny',
      statePending: 'Čaká na enrollment',
      stateNone: 'Bez enrollmentu',
      required: 'Povinnosť MFA',
      requiredChip: 'Povinné',
      notRequiredChip: 'Nepovinné',
      enrolledAt: 'Enrollment z',
      enrolledMethods: 'Metódy s enrollmentom',
      noMethods: 'Žiadny enrollment',
      codesRemaining: 'Zostávajúce kódy na obnovenie',
      resetTitle: 'Resetovať druhý faktor',
      resetHint:
        'Enrollment a všetky kódy na obnovenie sa vymažú: pri najbližšom prihlásení používateľ prejde enrollmentom odznova. Povinnosť MFA zostáva, ako je — správca tajomstvo nikdy nenastavuje, iba ho maže.',
      resetConfirm: 'Resetovať',
      resetError: 'Druhý faktor sa nepodarilo resetovať',
      empty: 'Zatiaľ žiadny spravovaný používateľ — účty sa tu objavia, len čo existujú, každý so svojím stavom druhého faktora.',

      // Metà B (round #178): provenienza del verdetto efficace, enrollment
      // esterni con lo stato orfano, gruppi che impongono l'obbligo.
      viaSelf: 'Osobné',
      viaSelfHint: 'Osobný príspevok účtu (jeho príznak) — jediná časť, ktorú ceruzka upravuje.',
      viaGroupHint: 'Povinnosť zdedená z tejto skupiny: odstránenie osobného príznaku používateľa neoslobodí — zasahuje sa na skupine, na karte Skupiny.',
      subject: 'Identita',
      lastSeenAt: 'Posledné potvrdenie',
      enrollmentPending: 'Čaká sa',
      orphanChip: 'Osirotený',
      orphanDirectoryMiss: 'Identita už nie je v adresári',
      orphanRealmRemoved: 'Realm bol z TVirt odobratý',
      orphanedAt: 'Osirotený od',
      directoryUuid: 'UUID v adresári',
      externalTitle: 'Externé enrollmenty',
      externalEmpty: 'Zatiaľ žiadny externý enrollment — vzniká pri prvom prihlásení adresárovej identity s povinnosťou MFA.',
      orphanHelp:
        'Osirotený enrollment sa nikdy nemaže sám od seba: je to bezpečnostný materiál — zostáva pre audit a ak sa identita v adresári znova objaví, nájde svoj faktor späť. Jediným východiskom je administratívny reset.',
      visibilityHint: 'Externé enrollmenty sídlia v koreni klastra: vidí ich len ten, kto má user.read nad celým stromom.',
      orphanResetHint:
        'Osirotený riadok sa odstráni natrvalo: už si ho nikto nenárokuje. Ak sa identita v adresári znova objaví, prejde enrollmentom odznova.',
      enforcingTitle: 'Skupiny vynucujúce MFA',
      enforcingSubtitle:
        'Kotvou povinnosti pre externé identity je skupina: jej mapovania realmov hovoria, ktorú populáciu adresára zasahuje. Externý enrollment vzniká pri prvom prihlásení používateľa s povinnosťou.',
      enforcingEmpty: 'Žiadna skupina nevynucuje MFA — povinnosť sa zapína na skupine, na karte Skupiny.',
      enforcingError: 'Nepodarilo sa načítať skupiny vynucujúce MFA'
    }
  },
  realms: {
    title: 'Autentifikačné realmy',
    createTitle: 'Vytvoriť realm',
    editTitle: 'Upraviť realm',
    name: 'Realm',
    nameHint: 'Doména, ktorú používatelia píšu za @ (example.com) — po vytvorení nemenná',
    nameImmutableHint: 'Názov realmu je vyrazený v každej relácii a v každom riadku auditu, ktorý ho kedy spomenul — premenovanie by prepísalo históriu',
    kind: 'Typ',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC a SAML prídu v nasledujúcich roundoch — dnes je realm adresárom LDAPv3',

    // Semi-wizard di creazione (round realm-wizard, 2026-08-03): le card dei
    // tipi del passo 1 — ldap vivo, oidc/saml card in roadmap (mai un form
    // senza un backend dietro).
    kindCategory: 'Typ realmu',
    kindSelectHint: 'Vyberte typ adresára, voči ktorému bude tento realm autentifikovať.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username a heslo overené bindom na adresári LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on z prehliadača delegovaný na identity provider OpenID Connect — príde v nasledujúcich roundoch.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Podnikový single sign-on cez asercie SAML 2.0 — príde v nasledujúcich roundoch.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Povolený',
    urls: 'Adresárové servery',
    urlsHint: 'Jedna URL ldap:// alebo ldaps:// na riadok (1–8), skúšané v poradí — failover, nikdy vyvažovanie',
    startTls: 'StartTLS',
    verifyCertificate: 'Overovať certifikát',
    cleartextWarning: 'Bez ldaps:// alebo StartTLS prechádza heslo bindu sieťou v čitateľnej podobe — prijateľné v laboratóriu, nikdy v produkcii.',
    noVerifyWarning: 'Neoverená relácia TLS neautentifikuje nikoho: overovanie vypnite len voči adresáru, ktorý nemôžete opraviť.',
    caCertificate: 'Certifikát CA (PEM)',
    caCertificateHint: 'Voliteľný bundle CA pripnutý pre handshake TLS/StartTLS tohto realmu; prázdne ho odstráni',
    caCertificatePinned: 'Pripnutý',
    connectTimeout: 'Timeout (sekundy)',
    connectTimeoutHint: 'Lehota pripojenia a požiadavky na jednu URL (1–60); po jej uplynutí sa skúsi ďalšia URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Service account, ktorý vykonáva vyhľadanie používateľa; prázdne = anonymný search bind (AD ho odmieta)',
    anonymousBind: 'Anonymný search bind',
    bindCredential: 'Heslo bindu (keystore)',
    bindCredentialHint: 'Položka usernamePassword v keystore s heslom bindu — tajomstvo nikdy nežije na realme',
    bindCredentialNone: 'Žiadne (anonymný bind)',
    bindCredentialEmpty: 'V keystore nie je žiadna položka usernamePassword — vytvorte ju v Systém > Poverenia pre heslo bindu.',
    baseDn: 'Base DN',
    baseDnHint: 'Podstrom, od ktorého sa začína vyhľadávanie používateľa (DC=example,DC=com)',
    userFilter: 'Filter používateľa',
    userFilterHint: '%u sa nahrádza lokálnou časťou loginu s escapovaním podľa RFC 4515; adresáre mimo AD typicky chcú (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atribút memberOf',
    memberOfAttributeHint: 'Číta sa len raz, pri prihlásení — nemapované skupiny sa ignorujú, vnorenie sa nerieši',
    uuidAttribute: 'Atribút UUID',
    uuidAttributeHint: 'Nemenný UUID v rámci realmu (objectGUID na AD, entryUUID na OpenLDAP) — vyrazený v audite vedľa používateľ@realm',
    displayNameAttribute: 'Atribút zobrazovaného mena',
    displayNameAttributeHint: 'Používa sa na pozdravenie používateľa; ak chýba, použije sa prihlasovacie meno',
    sudoHint: 'Zápisy na realmoch sú chránené režimom sudo: realm je dverami do platformy',
    deleteBody: 'Mapovania skupín realmu odchádzajú s ním; relácie, ktoré autentifikoval, zostávajú živé až do vypršania — odstránený realm jednoducho už nikoho nevpustí.',
    tabConnection: 'Pripojenie',
    tabDirectory: 'Adresár',
    testTitle: 'Test pripojenia',
    testHint: 'Konfiguračná sonda, nikdy autentifikácia: pripojí sa, urobí bind ako service account a — s používateľským menom — spustí filter používateľa.',
    testUsername: 'Používateľské meno (voliteľné)',
    testUsernameHint: 'Lokálna časť, na ktorej sa spustí filter používateľa — 1 zhoda je zdravá odpoveď',
    testRun: 'Spustiť test',
    testError: 'Sondu sa nepodarilo spustiť',
    testReachable: 'Adresár dostupný, servisný bind prijatý',
    testUnreachable: 'Adresár NIE JE dostupný',
    matchedOne: 'Filter používateľa našiel presne 1 položku — zdravá odpoveď.',
    matchedNone: 'Filter používateľa nenašiel žiadnu položku: filter alebo Base DN je nesprávny.',
    matchedMany: 'Zhôd filtra používateľa: {count} — filter nie je selektívny a prihlásenia by boli nejednoznačné (odmietnuté).',
    mappingsPointer: 'Čomu zodpovedá externá skupina, je vlastnosťou skupiny TVirt (jej mapovania realmov): bod pravdy žije na karte Skupiny.',
    mappingsPointerLink: 'Otvoriť kartu Skupiny',
    rootHomeHint: 'Identity externého realmu žijú v koreni klastra, nikdy vo vDC: oprávnenia sa prideľujú tam, kde ich treba, delegáciami — na skupine alebo priamo na používateľovi, presne ako pri natívnych.'
  },
  credentials: {
    title: 'Poverenia',
    createTitle: 'Vytvoriť poverenia',
    editTitle: 'Upraviť poverenia',
    kind: 'Typ',
    kindUsernamePassword: 'Username a heslo',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identita Ceph)',
    kindHintUsernamePassword: 'Nemenné. Pre úložiská CIFS/SMB — účet pre mount, ktorého tajomstvo worker použije v čase mountu.',
    kindHintIscsiChap: 'Nemenné. Pre autentifikáciu CHAP iSCSI — username = meno CHAP, secret = tajomstvo CHAP.',
    kindHintNvmeDhchap: 'Nemenné. Pre DH-HMAC-CHAP protokolu NVMe over Fabrics — secret = blob DHHC-1:xx:…; username je len označenie.',
    kindHintCephx: 'Nemenné. Pre klientov Ceph — username = meno klienta (client.…), secret = kľúč base64.',
    kindImmutableHint: 'Typ je po vytvorení nemenný — jeho zmena znamená nové poverenia.',
    username: 'Používateľské meno',
    usernameChap: 'Meno CHAP',
    usernameNvme: 'Označenie',
    usernameCephx: 'Meno klienta',
    usernameHint: 'Voliteľný účet, ktorému tajomstvo patrí',
    usernameHintChap: 'Meno CHAP, ktorým sa initiator autentifikuje',
    usernameHintNvme: 'Transport ho nepoužíva — voľné označenie pre vaše poznámky',
    usernameHintCephx: 'Meno klienta cephx — predpona client. je tolerovaná',
    secret: 'Tajomstvo',
    secretHint: 'Len na zápis: používajú ho konzumenti, už sa nikdy nezobrazí.',
    secretHintNvmeDhchap: 'Len na zápis: hostiteľské tajomstvo DH-HMAC-CHAP v kanonickej forme DHHC-1:xx:… — používajú ho konzumenti, už sa nikdy nezobrazí.',
    secretHintCephx: 'Len na zápis: kľúč cephx v base64 — používajú ho konzumenti, už sa nikdy nezobrazí.',
    secretEditHint: 'Nechajte prázdne, ak tajomstvo nechcete meniť — jeho vyplnenie ho rotuje.',
    createdAt: 'Vytvorené',
    inUseError: 'Na \'{name}\' sa odkazuje konfigurácia úložiska — najprv ich tam odpojte.',
    nameHint: 'Malé písmená, číslice a pomlčky (DNS-1123); jedinečné v rámci scope',

    // Dialog di sola rotazione (round #156): il segreto non ha mai la matita inline.
    rotateTitle: 'Rotovať tajomstvo',
    rotateHint: 'Len na zápis: nové tajomstvo nahradí uložené — konzumenti ho použijú pri najbližšom mounte.',

    // Round #159 (PKI): i tab Certificati e CA.
    tabSecrets: 'Tajomstvá',
    tabCertificates: 'Certifikáty',
    tabAuthorities: 'Certifikačné autority',
    certificatesTitle: 'Certifikáty',
    authoritiesTitle: 'Certifikačné autority',
    caCreateTitle: 'Nová CA',
    certCreateTitle: 'Nový certifikát',
    caMode: 'Pôvod',
    caModeGenerate: 'Vygenerovať v TVirt',
    caModeImport: 'Importovať (kľúč + certifikát)',
    certMode: 'Pôvod',
    certModeIssue: 'Vydať z CA v keystore',
    certModeImport: 'Importovať (kľúč + certifikát)',
    issuingCa: 'Vydávajúca CA',
    issuingCaHint: 'Certifikát vzniká v scope danej CA, so zaznamenaným parentom',
    noCasHint: 'V keystore nie je žiadna CA — najprv nejakú vygenerujte alebo importujte na karte CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject CA: písmená, číslice, medzera, bodka, podčiarkovník, pomlčka',
    commonNameCertHint: 'OpenVPN identifikuje klientov podľa CN — udržujte ho jedinečný v rámci CA',
    days: 'Platnosť (dni)',
    daysCaHint: '1–7300 dní; predvolené je 3650 (10 rokov)',
    daysCertHint: '1–3650 dní; predvolené je 365',
    keyType: 'Typ kľúča',
    keyTypeHint: 'Predvolený je EC P-256; RSA pre legacy konzumentov',
    usage: 'Použitie',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Extended key usage, na ktoré sa certifikát vydáva',
    san: 'Alternatívne názvy (SAN)',
    sanHint: 'Oddelené čiarkami; IP literály sa stanú položkami IP:, zvyšok DNS:',
    keyPem: 'Súkromný kľúč (PEM)',
    keyPemHint: 'Len na zápis: uschovaný v keystore, už sa nikdy nezobrazí',
    certPem: 'Certifikát (PEM)',
    certPemHint: 'Verejný certifikát, ktorý sa páruje s kľúčom',
    certPemCaHint: 'Certifikát CA, ktorý sa páruje s kľúčom (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Vydavateľ',
    parentCa: 'Vydávajúca CA',
    parentCaImported: 'Importovaný — vydaný mimo TVirt',
    serial: 'Sériové číslo',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Platný od',
    validUntil: 'Platný do',
    expiry: 'Vypršanie',
    expired: 'Platnosť vypršala',
    expiresInDays: 'Vyprší o {days} d',
    revoked: 'Odvolaný',
    revokedAtLabel: 'Odvolaný dňa',
    revokeTitle: 'Odvolať certifikát',
    revokeAction: 'Odvolať',
    revokeWarning: 'Odvolanie je definitívne: sériové číslo vstúpi do CRL vydávajúcej CA a každý konzument odmietajúci odvolané certifikáty (OpenVPN v prvom rade) tento odmietne. Un-revoke neexistuje.',
    exportPem: 'Exportovať PEM',
    exportChain: 'Exportovať bundle reťaze',
    exportCrl: 'Exportovať CRL',
    materialImmutableHint: 'Materiál X.509 je nemenný — vydajte znova alebo importujte znova',
    caInUseError: '\'{name}\' má ešte živé vydané certifikáty (alebo sa na ňu odkazuje úložisko) — najprv ich odvolajte alebo odstráňte.'
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Umiestňovanie, dostupnosť a afinita — kde bežia VM klastra a či majú byť zapnuté',
    loadError: 'Panel Proximity vyžaduje store klastra — stav flotily je teraz nedostupný',
    config: {
      title: 'Konfigurácia',
      subtitle: 'Politika umiestňovania na úrovni klastra',
      save: 'Uložiť',
      saveError: 'Konfigurácia bola odmietnutá',
      strategy: 'Stratégia výberu',
      strategy_leastUsedResources: 'Najmenej využité zdroje',
      strategy_leastVms: 'Najmenej VM',
      strategy_random: 'Náhodná',
      strategyLeastUsedResourcesHint: 'Spomedzi platných kandidátov uzol s najväčšou zostávajúcou použiteľnou RAM (pozorovaný celok − rezerva hostiteľa − zapnuté VM), pri remíze rozhoduje záväzok vCPU. Deterministická pri rovnakých údajoch.',
      strategyLeastVmsHint: 'Spomedzi platných kandidátov uzol s najmenším počtom zapnutých VM; remízy sa riešia podľa názvu. Deterministická pri rovnakých údajoch.',
      strategyRandomHint: 'Rovnomerne náhodný výber spomedzi platných kandidátov.',
      liveness: 'Prah živosti uzlov (sekundy)',
      livenessHint: 'Člen mlčiaci dlhšie než prah je nedostupný: vylúčený z umiestňovania a — ak nie je v údržbe — považovaný za mŕtveho deciderom HA, ktorý ho odstaví fencingom a jeho HA VM reštartuje inde.',
      decider: 'Decider HA',
      deciderNone: 'zatiaľ nezvolený'
    },
    nodesTitle: 'Uzly',
    nodesSubtitle: 'Živosť a empirická kapacita — použiteľná RAM = celková − základná − viazaná',
    nodeCol: 'Uzol',
    stateCol: 'Stav',
    ramCol: 'RAM (celková − základná − viazaná)',
    usableCol: 'Použiteľná',
    vmsCol: 'Záťaž',
    neverSeen: 'nikdy nevidený',
    freshChip: 'dostupný',
    staleChip: 'nedostupný',
    attestedChip: 'atestovane vypnutý',
    ramFormula: 'celková − základná − viazaná',
    haTitle: 'Vysoká dostupnosť',
    haSubtitle: 'VM s príznakom HA sú „vždy zapnuté“: TVirt ich reštartuje po každom nevyžiadanom zastavení — rovnaký uzol s backoffom, iný uzol, keď ten ich zomrie (len zdieľané úložisko).',
    haNone: 'Žiadna VM zatiaľ nemá príznak HA — povoľte ho tu alebo v detaile VM.',
    haVmCol: 'Virtuálny stroj',
    haStateCol: 'Stav',
    haRestartsCol: 'Reštarty HA',
    haLastEventCol: 'Posledná udalosť',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'Zmena HA bola odmietnutá',
    rules: {
      title: 'Pravidlá afinity',
      createTitle: 'Nové pravidlo blízkosti',
      editTitle: 'Upraviť pravidlo',
      nameHint: 'Malé písmená, číslice a pomlčky (DNS label)',
      vms: 'Virtuálne stroje',
      vmsHint: 'Aspoň dve VM — pravidlo viaže, kde bežia jedna voči druhej',
      type: 'Typ',
      affinity: 'Afinita (spolu)',
      antiAffinity: 'Anti-afinita (oddelene)',
      typeAffinityHint: 'VM majú bežať na ROVNAKOM uzle.',
      typeAntiAffinityHint: 'VM majú bežať na RÔZNYCH uzloch — klasická dvojica HA.',
      mode: 'Režim',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Porušenia odmietnu operáciu (spustenie, migrácia, failover) s výrečnou chybou.',
      modeSoftHint: 'Preferencia, nikdy nie blokujúca: umiestnenie v rozpore pokračuje s viditeľným upozornením.',
      satisfied: 'Umiestnenie',
      satisfiedYes: 'dodržané',
      satisfiedNo: 'porušené',

      // Dialog standard (round #156): le violazioni hanno la loro riga, non un tooltip.
      violations: 'Porušenia',
      noViolations: 'Žiadne'
    },
    events: {
      title: 'Udalosti HA',
      subtitle: 'Žurnál dostupnosti — reštarty, fencing, failovery a poctivé preskočenia',
      none: 'Zatiaľ nič.',
      when: 'Kedy',
      kind: 'Udalosť',
      target: 'Cieľ',
      detail: 'Detail',
      kindRestarted: 'reštart HA',
      kindGaveUp: 'vzdané (crash loop)',
      kindNodeAttested: 'fencing uzla',
      kindFailedOver: 'failover',
      kindNoCandidate: 'žiadny kandidát',
      kindStorageLocalSkip: 'preskočené (lokálne úložisko)',
      kindZombieFenced: 'zombie ukončený'
    }
  }
}
